import { isDarkMode } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    designVersion,
    black,
    white
  } = _ref;
  return {
    rootStyle: {
      background: white ? isDarkMode(designVersion) ? '#17120F' : '#FFFFFF' : black ? isDarkMode(designVersion) ? '#FFFFFF' : '#17120F' : '#FFB3C7',
      logo: white ? isDarkMode(designVersion) ? '#FFFFFF' : '#17120F' : black ? isDarkMode(designVersion) ? '#17120F' : '#FFFFFF' : '#17120F'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map